<template>
    <div v-if="Object.hasOwnProperty.call(examInfo,'name')" class="exam_header">
        <span class="title">{{examInfo.name}}</span>
        <span class="total_score">考试总分：{{examInfo.total_score}}分</span>
        <span v-if="examInfo.content" class="attachment" @click="openAttachment">附件提示</span>
        <span v-if="examInfo.score!==''" class="score">得分：{{examInfo.score}}分</span>
    </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
    computed: mapState([
        'examInfo'
    ]),
    props:{
        obj:{
            type: Object,
            defalut: () => {},
        }
    },
    mounted() {
    },
    methods: {
        openAttachment() {
            if (!this.examInfo.content) return;
            sessionStorage.setItem('exam_attachment_content', this.examInfo.content);
            const routeUrl = this.$router.resolve({
                path: '/examAttachment'
            });
            window.open(routeUrl.href, '_blank');
        }
    }
}
</script>
<style lang="scss" scoped>
.exam_header{
    height:56px;
    line-height: 55px;
}
.title{
    color: #333;
    font-size: 18px;
    font-weight: 700;
    padding-left: 15px;
    margin-right: 40px;
}
.total_score{
    color: grey;
    font-size: 14px;
    font-weight: 500;
    margin-right: 40px;
}
.attachment{
    color: #409EFF;
    font-size: 14px;
    font-weight: 500;
    margin-right: 40px;
    cursor: pointer;
    text-decoration: underline;
}
.attachment:hover {
    color: #66b1ff;
}
.score{
    color: grey;
    font-size: 15px;
    font-weight: 500;
}
</style>
